import type { CSSObject } from 'styled-components';

import { flattenStyle, StyleProp } from '@adsk/alloy-react-theme';

import type { Typography } from '../Theme';

export const getTextTypography = (
  type: Typography | undefined,
  style?: StyleProp | null,
): CSSObject | undefined => {
  return {
    ...(type === 'ellipsis' && {
      display: 'block',
    }),
    ...flattenStyle(style),
  };
};
